<template lang="html">
  <div v-if="isMultipleMessages()" class="ma-0">
    <v-alert v-for="item in message" v-bind:type="type" :key="message.indexOf(item)" dismissible class="alert-msg">
      {{ item }}
    </v-alert>
  </div>
  <v-alert v-else v-bind:type="type" dismissible class="alert-msg">
    {{ message }}
  </v-alert>
</template>

<script>
  export default {
    name: "Flash",

    props: ["message", "type"],

    methods: {
      isMultipleMessages() {
        return this.$_.isArray(this.message);
      },
    },

    created() {
      setTimeout(() => {
        this.$store.commit("dismissError");
      }, 15000);
    },
  };
</script>

<style scoped>
  .alert-msg {
    position: fixed;
    top: 0;
    z-index: 9999;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Flash.vue